import { topicsData } from '@/mocks/home';

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-10 text-center font-heading">热门话题</h2>
        <div className="max-w-5xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
            {topicsData.slice(0, 9).map((item, i) => (
              <div
                key={i}
                className="flex items-center justify-between p-4 rounded-lg bg-background-100 border border-background-200/70 hover:border-primary-200/60 cursor-pointer transition-all duration-200 group"
              >
                <div className="flex items-center gap-3 min-w-0">
                  <span className="text-xs font-bold text-foreground-400 w-5 flex-shrink-0 text-right">{String(i + 1).padStart(2, '0')}</span>
                  <div className="min-w-0">
                    <div className="flex items-center gap-2">
                      <span className="text-sm font-medium text-foreground-900 group-hover:text-primary-600 transition-colors whitespace-nowrap truncate">{item.name}</span>
                      {item.tag && (
                        <span className={`flex-shrink-0 px-1.5 py-0.5 text-[9px] font-bold rounded whitespace-nowrap ${
                          item.tag === '爆'
                            ? 'bg-accent-500 text-background-50'
                            : item.tag === '热'
                            ? 'bg-primary-500 text-background-50'
                            : 'bg-secondary-500 text-background-50'
                        }`}>{item.tag}</span>
                      )}
                    </div>
                    <div className="text-[10px] text-foreground-400 mt-0.5">{item.posts.toLocaleString()} 帖</div>
                  </div>
                </div>
                <div className="flex-shrink-0 text-right">
                  <div className="text-sm font-semibold text-accent-600 font-heading whitespace-nowrap">{item.heat}</div>
                  <div className="text-[10px] text-foreground-400">热度</div>
                </div>
              </div>
            ))}
          </div>
          <div className="mt-4 flex flex-wrap justify-center gap-2">
            {topicsData.slice(9).map((item, i) => (
              <span
                key={i + 9}
                className="px-3 py-1.5 text-xs text-foreground-600 bg-background-100 rounded-full border border-background-200/70 hover:border-primary-200/60 hover:text-primary-600 cursor-pointer transition-all whitespace-nowrap"
              >
                {item.name}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}